import { useCallback, useEffect, useState } from 'react'
import cls from 'classnames'
import styles from './PageLayout.module.less'
import { ROOT_CONTAINER_ID } from '@/router/pageConst'
import { Outlet, } from 'react-router-dom'
import { observer } from 'mobx-react'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'
import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import LayoutHeaderPc from './components/LayoutHeaderPc/LayoutHeaderPc'
import LayoutHeaderMobile from './components/LayoutHeaderMobile/LayoutHeaderMobile'
import { corpService } from '@/services/corpService'

function PageLayout() {
  const isMobile = useIsMobile()
  const [scrollTop, setScrollTop] = useState(0)
  const handleBodyScroll = useCallback((e: Event) => {
    const root = e.target as HTMLDivElement
    setScrollTop(root.scrollTop)
  }, [])

  useEffect(() => {
    corpService.getCorpInfo()
    const rootEl = document.getElementById(ROOT_CONTAINER_ID) as HTMLDivElement
    rootEl.addEventListener('scroll', handleBodyScroll)
    return () => {
      rootEl.removeEventListener('scroll', handleBodyScroll)
    }
  }, [])


  return (
    <ErrorBoundary>
      <div className={cls(styles.pageLayout)}>
        {isMobile ? <LayoutHeaderMobile scrollTop={scrollTop} /> : <LayoutHeaderPc scrollTop={scrollTop} />}
        <div className={cls(styles.layoutBody)}>
          <Outlet />
        </div>
      </div>
    </ErrorBoundary>
  )
}


export default observer(PageLayout)
